import { render, staticRenderFns } from "./SupplierIndex.vue?vue&type=template&id=f6df81c2"
import script from "./SupplierIndex.vue?vue&type=script&lang=js"
export * from "./SupplierIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports